<ng-container *transloco="let t;">
<app-detail-view [loading]="loading" [messages]="messages" (closed)="onClose()">

  <div title>
    <h1>
      <span *ngIf="newMode()">{{ t('common.labels.create_template') }}</span>
      <span *ngIf="editMode()">{{ t('common.labels.template') }} <strong>{{ template.name }}</strong><i *ngIf="template.status === 'inactive'">({{t('common.deactivated')}})</i></span>
    </h1>
  </div>

  <div details>
    <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="tabIndex">

      <p-tabPanel header="{{ t('common.labels.basedata') }}" leftIcon="pi pi-sliders-h" [disabled]="isDisabled('basedata')">
        <app-template-new *ngIf="newMode()"></app-template-new>
        <app-template-basedata *ngIf="editMode()" [template]="template" (setEdit)="setEdit($event)"></app-template-basedata>
      </p-tabPanel>

      <p-tabPanel header="{{ t('common.labels.exercises') }}" leftIcon="pi pi-briefcase" [disabled]="isDisabled('exercises') || template === null">
        <app-ac-exercises *ngIf="editMode()" [(ac)]="template" [mode]="'template'" (setEdit)="setEdit($event)"></app-ac-exercises>
      </p-tabPanel>

      <p-tabPanel header="{{ t('common.labels.onlinetests') }}" leftIcon="pi pi-inbox" [disabled]="isDisabled('onlinetests') || template === null">
        <app-template-onlinetests *ngIf="editMode()" [template]="template" [partners]="partners" (setEdit)="setEdit($event)"></app-template-onlinetests>
      </p-tabPanel>

      <p-tabPanel header="{{ t('common.labels.time_schedule') }}" leftIcon="pi pi-clock" [disabled]="isDisabled('timing') || template === null">
        <app-ac-timing *ngIf="editMode()" [ac]="template" [mode]="'template'" (setEdit)="setEdit($event)"></app-ac-timing>
      </p-tabPanel>

      <p-tabPanel header="{{ t('common.labels.files') }}" leftIcon="pi pi-copy" [disabled]="isDisabled('files') || template === null">
        <app-ac-files *ngIf="editMode()" [ac]="template" [mode]="'template'" (setEdit)="setEdit($event)"></app-ac-files>
      </p-tabPanel>

      <p-tabPanel header="{{ t('common.labels.todos') }}" leftIcon="pi pi-list" [disabled]="isDisabled('todos') || template === null">
        <app-template-todos *ngIf="editMode()" [(template)]="template" [languages]="languages" (setEdit)="setEdit($event)"></app-template-todos>
      </p-tabPanel>

    </p-tabView>
  </div>

</app-detail-view>
</ng-container>
